import React, { useState, useEffect } from 'react';
import {
    Grid,
    TextField,
    Typography,
    Card,
    Link,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainingCompanyRoutes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from "@mui/icons-material/Search";
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import editRoutes from "trainingCompanyEditRoutes";
import Advertisement from '../Advertisement/Advertisement';
import defaultRoutes from "routes";

const Page = () => {

    const [search, setSearch] = useState("");
    const [modeOfTraining, setModeOfTraining] = useState("");
    const [location, setLocation] = useState("");
    const [budget, setBudget] = useState("");
    const [budgetRangeFrom, setBudgetRangeFrom] = useState("");
    const [budgetRangeTo, setBudgetRangeTo] = useState("");
    const [showLocationField, setShowLocationField] = useState(false);
    const [skillsName, setSkillsName] = useState([]);
    const [trainerList, setTrainerList] = useState([]);
    const [bbdata, setbbData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedTrainer, setSelectedTrainer] = useState('');
    const [errorMessage, setErrorMessage] = useState("");

    const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const [mobVerified, setMobVerified] = useState(false);
    const [tcVerified, setTcVerified] = useState(false);

    const displayAdvertisement = process.env.REACT_APP_ADVERTISEMENT === 'yes';
    console.log("process.env.REACT_APP_ADVERTISEMENT", process.env.REACT_APP_ADVERTISEMENT);
    console.log("displayAdvertisement", displayAdvertisement);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setSkillsName(["ANY", ...data]);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("skillsName", skillsName);

    const navigate = useNavigate();

    const onSubmitClick = async () => {
        if (!search && !location && !budgetRangeFrom && !budgetRangeTo) {
            setErrorMessage("Please apply filters to search Trainer");
        } else {
            const queryString = `?search=${search}&location=${location}&budgetRangeFrom=${budgetRangeFrom}&budgetRangeTo=${budgetRangeTo}`;
            navigate(`/app/trainerlist${queryString}`);
        }
    };

    const handleSearchChange = (event, value) => {
        const typedSkill = event.target.value;
        console.log("typedSkill@@@@@@@@@@@@@", typedSkill);
        if (typedSkill && !skillsName.includes(typedSkill)) {
            fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    setSkillsName([...skillsName, ...data]);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        setSearch(value);
    };
    console.log("search", search);

    useEffect(() => {
        const id = localStorage.getItem("userId");
        let technology = search === "ANY" ? "" : search;
        const apiUrl = id
            ? `${process.env.REACT_APP_API_URL}/api/getSearchtech-trainerprofile/${id}/${technology}`
            : `${process.env.REACT_APP_API_URL}/api/getSearchtech-trainerprofile/${technology}`;

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setbbData(data);
                    setTrainerList(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [search, localStorage.getItem("userId")]);



    console.log("trainerList", trainerList);
    console.log("data", bbdata);


    const totalPages = bbdata.count > 0 ? Math.ceil(bbdata.count / bbdata.results.length) : 0;

    const onClearFilterClick = () => {
        setSearch("");
        setBudget("");
        setBudgetRangeFrom("");
        setBudgetRangeTo("");
        setLocation("");
        setErrorMessage("");
    };

    useEffect(() => {
        const id = localStorage.getItem("userId");

        if (id) {
            // Make the userdetails API call
            fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (!data.detail) {
                        setEmailVerified(data.is_verified);
                        setMobVerified(data.is_verified_mobile);
                        setTcVerified(data.is_verified_tc);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

            // Make the trainingcompanyprofileuidexists API call
            fetch(`${process.env.REACT_APP_API_URL}/api/trainingcompanyprofileuidexists/${id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('token'),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.exists === false && mobVerified === true && tcVerified === true && emailVerified === true) {
                        setTrainingCompanyProfileCreate(true);
                        window.location.href = "/app/trainingcompanyprofile";
                    } else {
                        setTrainingCompanyProfileCreate(false);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [localStorage.getItem("userId"), mobVerified, tcVerified, emailVerified]);
    console.log("trainingCompanyProfileCreate", trainingCompanyProfileCreate);



    return (
        <>
            <DefaultNavbar
                routes={localStorage.getItem("userId") ? (trainingCompanyProfileCreate ? routes : editRoutes) : defaultRoutes}
                sticky
            />
            <Card
                sx={{
                    height: '790px',
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Container maxWidth="sm">
                    <form>
                        <Grid container style={{ marginTop: "130px" }} spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
                                    <span style={{ color: 'black' }}>Search</span>{' '}
                                    <span style={{ color: '#2e1114' }}>Trainer</span>
                                </MKTypography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: '20px', marginLeft: '5px' }} spacing={2}>
                            <div>
                                <Typography variant="h5" style={{ color: 'black' }}>Search by Skills</Typography>
                                <Autocomplete
                                    multiple
                                    id="skills"
                                    options={skillsName}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Skill"
                                            variant="standard"
                                            style={{ marginTop: '10px', width: '700px' }}
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <SearchIcon fontSize="medium" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    onChange={(event, value) => handleSearchChange(event, value)}
                                />
                            </div>
                            <Grid item xs={12} md={8}>
                                <Grid item xs={12} md={10}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginLeft: '-20px' }}>
                                        {/* <Link href="#" onClick={onClearFilterClick} style={{ marginTop: '-15px', textDecoration: 'underline', color: 'blue', cursor: 'pointer', fontSize: 'small' }}>
                                            Clear Filters
                                        </Link> */}
                                        <MKButton variant="gradient" color="info" size="small" style={{ marginTop: '-15px', whiteSpace: 'nowrap' }} onClick={onClearFilterClick} >Clear Filters</MKButton>
                                        <MKButton variant="gradient" color="info" size="small" style={{ marginTop: '-15px', marginLeft: '10px' }} onClick={onSubmitClick} >Submit</MKButton>
                                    </div>
                                </Grid>
                                <div>
                                    {errorMessage && <Typography color="error" style={{ marginLeft: "-15px", marginTop: "10px", fontSize: "13px", lineHeight: "1.2" }}>{errorMessage}</Typography>}
                                </div>
                            </Grid>
                        </Grid>
                        {displayAdvertisement && <Advertisement />}
                    </form>
                </Container>
            </Card>
            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
                    <SimpleFooter />
                </MKBox>
            </div>
        </>
    );
}

export default Page;

